import { __assign, __read, __rest } from "tslib";
import { useState } from 'react';
import { useSingleCalendarState } from './useSingleCalendarState';
import { createRange, isInRange, isSameCell, isSameView } from './utils';
export function useRangeCalendarState(props) {
    var _a;
    var value = props.value, defaultValue = props.defaultValue, onChange = props.onChange, restProps = __rest(props, ["value", "defaultValue", "onChange"]);
    var _b = __read(useState(null), 2), highlightedDate = _b[0], setHighlightedDate = _b[1];
    var singleState = useSingleCalendarState(__assign(__assign({}, restProps), { value: (_a = value === null || value === void 0 ? void 0 : value.start) !== null && _a !== void 0 ? _a : undefined, onChange: function (event) {
            setHighlightedDate(highlightedDate ? null : event.value);
            onChange === null || onChange === void 0 ? void 0 : onChange({ value: createRange(highlightedDate, event.value) });
        } }));
    var activeView = singleState.activeView, focusedDate = singleState.focusedDate, focusDate = singleState.focusDate, getBaseCellState = singleState.getCellState;
    var highlightedRange = highlightedDate
        ? createRange(highlightedDate, focusedDate)
        : value && createRange(value.start, value.end);
    function highlightDate(date) {
        if (highlightedDate) {
            focusDate(date);
        }
    }
    function getCellState(cellValue, viewDate) {
        var baseCellState = getBaseCellState(cellValue, viewDate);
        var isHighlighted = highlightedRange
            ? isInRange(activeView, cellValue, highlightedRange)
            : false;
        var isHighlightedStart = (highlightedRange === null || highlightedRange === void 0 ? void 0 : highlightedRange.start)
            ? isSameCell(activeView, cellValue, highlightedRange.start)
            : false;
        var isHighlightedEnd = (highlightedRange === null || highlightedRange === void 0 ? void 0 : highlightedRange.end)
            ? isSameCell(activeView, cellValue, highlightedRange.end)
            : false;
        var hasHighlightDate = highlightedDate
            ? isSameCell(activeView, cellValue, highlightedDate)
            : false;
        var isRangePreview = Boolean(highlightedDate) && isHighlighted;
        var isSelectionStart = isRangePreview
            ? isHighlightedStart && hasHighlightDate
            : isHighlightedStart;
        var isSelectionEnd = isRangePreview ? isHighlightedEnd && hasHighlightDate : isHighlightedEnd;
        return __assign(__assign({}, baseCellState), { isDisabled: baseCellState.isDisabled || !isSameView(activeView, cellValue, viewDate), isRangePreview: Boolean(highlightedDate) && isHighlighted, isRangePreviewStart: isRangePreview && isHighlightedStart, isRangePreviewEnd: isRangePreview && isHighlightedEnd, isRangeSelected: !highlightedDate && isHighlighted, isSelectionStart: isRangePreview
                ? isHighlightedStart && hasHighlightDate
                : isHighlightedStart, isSelectionEnd: isRangePreview ? isHighlightedEnd && hasHighlightDate : isHighlightedEnd, isSelected: isSelectionStart || isSelectionEnd });
    }
    return __assign(__assign({}, singleState), { mode: 'range', value: value, highlightDate: highlightDate, getCellState: getCellState });
}
